<hyperkit-dialog class="hyperkit-component" headerText="Edit Hunt Template">
  <div class="container-fluid">
    <div class="row">
      <div class="container">
        @if (error) {
          <hyperkit-error [error]="error"></hyperkit-error>
        }
        @if (formGroup) {
          <form
            class="k-form"
            [formGroup]="formGroup"
            autocomplete="off"
            (ngSubmit)="onSubmit()"
          >
            <hyperkit-input
              class="hyperkit-component"
              type="text"
              id="name"
              label="Name"
              maxlength="50"
              formControlName="name"
            >
            </hyperkit-input>
            <hyperkit-multiselect
              label="Environments"
              [options]="environments"
              displayProperty="name"
              formControlName="environments"
              valueProperty="id"
              (selectionChange)="onValueChange()"
            >
            </hyperkit-multiselect>
            <hyperkit-select
              label="Priority"
              [options]="priorities"
              formControlName="priority"
            ></hyperkit-select>
            <hyperkit-select
              label="Default Assignee"
              [displayProperty]="'fullName'"
              [valueProperty]="'id'"
              [options]="assignees$ | async"
              formControlName="defaultAssignee"
            ></hyperkit-select>
            <hyperkit-textarea
              label="Description"
              placeholder="Enter a detailed description"
              formControlName="description"
            >
            </hyperkit-textarea>
            <hyperkit-textarea
              label="Hypothesis"
              placeholder="Enter the hypothesis for the hunt"
              formControlName="hypothesis"
            >
            </hyperkit-textarea>
            <hyperkit-button
              size="small"
              color="tertiary"
              text="Save"
              type="submit"
              [disabled]="!formGroup.valid"
            ></hyperkit-button>
          </form>
        }
      </div>
    </div>
  </div>
</hyperkit-dialog>
<ng-template #loading>
  <p>Loading…</p>
</ng-template>
